import { CincClientType } from "../../enums/CincClientType";
import { Company } from "../../enums/Company";

export class AdAccountCreationRequest{
    public ClientFullName!: string;
    public DomainName!: string;
    public States!: string[];
    public Brokerage!: string;
    public TimeZone!: string;
    public Company!: Company;
    public CincClientType!: CincClientType;
}